import React from 'react';

import * as Checkbox from '@radix-ui/react-checkbox';
import { useField } from 'formik';

import { ICONS } from 'shared/presentation/constants';

import * as S from './styles';

const Icon = ICONS.CHECK;

const getLabel = (label: string, required?: boolean) => {
  if (!required) return label;

  return label + ' *';
};

interface IRadioInputProps<T> {
  name: string;
  label?: string;
  onValueChange?: (value: T) => void;
  disabled?: boolean;
  className?: string;
  options: Array<{ label: string; value: T }>;
  required?: boolean;
}

function RadioInput<T>({
  name,
  label,
  className,
  disabled,
  onValueChange,
  options,
  required,
}: IRadioInputProps<T>) {
  const [field, meta, helpers] = useField<T>({ name });
  const hasError = Boolean(meta.error && meta.touched);

  return (
    <S.Container className={className}>
      {!!label && <label htmlFor={name}>{getLabel(label, required)}</label>}

      <ul>
        {options.map(option => {
          const id = name + option.value;

          return (
            <li key={String(option.value)}>
              <Checkbox.Root
                checked={field.value === option.value}
                onCheckedChange={() => {
                  helpers.setValue(option.value);
                  if (onValueChange) onValueChange(option.value);
                }}
                name={id}
                id={id}
                disabled={disabled}
                data-error={hasError}
              >
                <Checkbox.Indicator>
                  <Icon />
                </Checkbox.Indicator>
              </Checkbox.Root>

              <label htmlFor={id}>{option.label}</label>
            </li>
          );
        })}
      </ul>

      {hasError && <span>{meta.error}</span>}
    </S.Container>
  );
}

export default RadioInput;
